import { FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getIsAddressExemptionAvailable } from '@features/contacts/utils/getIsAddressExemptionAvailable'
import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'

import { useMissingCustomerDetailsForm } from '../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressExemption } from './elements/CustomerAddressExemption'
import { CustomerCity } from './elements/CustomerCity'
import { CustomerCountry } from './elements/CustomerCountry'
import { CustomerPobox } from './elements/CustomerPobox'
import { CustomerStreetAddress1 } from './elements/CustomerStreetAddress1'
import { CustomerStreetAddress2 } from './elements/CustomerStreetAddress2'

export const CustomerAddressSection = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { watch },
  } = useMissingCustomerDetailsForm()
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  const [customerCountry, customerType, isAddressExempt] = watch(['address.country', 'customerType', 'isAddressExempt'])
  const shouldShowAddressExemption = getIsAddressExemptionAvailable({
    customerCountry,
    customerType,
    isFrenchComplianceMode,
  })
  const isAddressDisabled = shouldShowAddressExemption && !!isAddressExempt

  return (
    <FormItemsGroup rowSpacing={Spacing.S16}>
      <Text variant="h3">
        {t('external_invoices.missing_customer_compliance_details.modal.form.billing_address_section.header')}
      </Text>
      <CustomerStreetAddress1 isDisabled={isAddressDisabled} />
      <CustomerStreetAddress2 isDisabled={isAddressDisabled} />
      <FormItemsGroup itemsInRow={2}>
        <CustomerPobox isDisabled={isAddressDisabled} />
        <CustomerCity isDisabled={isAddressDisabled} />
      </FormItemsGroup>
      <CustomerCountry isDisabled={isAddressDisabled} />
      {shouldShowAddressExemption && <CustomerAddressExemption />}
    </FormItemsGroup>
  )
}
